import React, { Component, useEffect, useLayoutEffect, useState } from 'react';
import * as R from 'ramda';
import Reporter from './Reporter';
import axios from 'axios';
import Model from '../Components/Model';
import {
  MODEL_EXP,
  MODEL_FIRE,
  MODEL_STANDARD,
} from '../Services/ValueTransform';
export default ({}) => {
  const [models, setModels] = useState([]);
  const [modelType, setModelType] = useState(MODEL_STANDARD);
  const [selecteds, setSelected] = useState([]);
  const [sizeSelected, setSizeSelected] = useState({});
  const [fans, setFans] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(-1);

  const getModels = () => {
    axios.get('/api/v1/models').then(({ data }) => {
      if (data.success) {
        setModels(Object.values(data.payload.models));
      }
    });
  };

  const toggleSelectSize = (e, modelId, type) => {
    // e.preventDefault();
    const selected = sizeSelected[modelId];
    if (!selected) {
      setSizeSelected({ ...sizeSelected, [modelId]: [type] });
    } else {
      const existed = R.indexOf(type, selected);
      if (existed >= 0) {
        //remove
        setSizeSelected({
          ...sizeSelected,
          [modelId]: R.without([type], selected),
        });
      } else {
        //add
        setSizeSelected({
          ...sizeSelected,
          [modelId]: R.append(type, selected),
        });
      }
    }
  };

  const handleSelectType = (e, type) => {
    e.preventDefault();
    setModelType(type);
    setSelected([]);
    setSizeSelected({});
  };

  const handleSelect = (parentId, modelIds) => {
    const updated = R.uniq(R.concat(selecteds, [...modelIds, parentId]));
    setSelected([...updated]);
  };

  const handleDeselect = (modelIds, parentId = null) => {
    const outs = [...modelIds];
    if (parentId) {
      outs.push(parentId);
    }
    const updated = R.filter((item) => !R.includes(item, outs), selecteds);
    setSelected([...updated]);

    //clear size
    const sizes = R.omit(modelIds, sizeSelected);
    setSizeSelected(sizes);
  };

  const handleSearch = (form) => {
    setFans([]);
    setLoading(true);
    const sizes = R.pick(selecteds, sizeSelected);
    const emptyList = [];
    R.forEachObjIndexed((val, mid) => {
      if (!val || R.isEmpty(val)) emptyList.push(mid);
    }, sizes);

    const sizeParams = R.omit(emptyList, sizes);
    axios
      .post('/api/v1/search', {
        ...form,
        modelType,
        models: selecteds,
        sizes: R.isEmpty(sizeParams) ? null : sizeParams,
      })
      .then(({ data }) => {
        if (data.success) {
          setFans(data.payload.fans);
        } else {
          setFans([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getModels();
  }, []);
  useLayoutEffect(() => {
    window.startAccordion();
    setTimeout(() => {
      window.startAccordion();
    }, 500);
  }, [models]);

  return (
    <section class='bg-white pt-[90px] pb-5 md:pt-[120px] md:pb-0'>
      <div
        class='container bg-light'
        id='fanContainers'
        style={{ maxWidth: '100%', overflow: 'auto' }}
      >
        <div class='grid grid-cols-1'>
          <div class='flex mt-3'>
            <div
              style={{
                width: 300,
                backgroundColor: '#7d8ec18f',
              }}
            >
              <div class='py-3'>
                <div
                  class='flex items-center gap-3 px-3'
                  style={{
                    paddingBottom: 5,
                    borderBottom:
                      '1px solid rgb(10 161 149 / var(--tw-bg-opacity))',
                  }}
                >
                  <div
                    class='shrink-0 h-12 w-12 leading-[48px] rounded-full text-center text-2xl'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img src='/minilogo.png' />
                  </div>
                  <h5 class='font-bold text-xl'>Products</h5>
                </div>
                <div class='px-6 py-6'>
                  <ul class='flex items-center space-x-3 justify-center'>
                    <li
                      class='shrink-0'
                      style={
                        modelType === MODEL_STANDARD
                          ? { backgroundColor: '#7d8ec1' }
                          : {}
                      }
                    >
                      <a
                        onClick={(e) => handleSelectType(e, MODEL_STANDARD)}
                        href='#'
                        class='flex flex-col items-center text-dark hover:text-custom duration-300 px-2 leading-10 rounded-full block text-[26px] text-center'
                      >
                        <img
                          src='/standardfan.png'
                          style={{
                            objectFit: 'contain',
                            width: 'auto',
                            height: '50px',
                            paddingTop: 7,
                          }}
                        />
                        <h4 class='font-bold text-xs'>Standard Fan</h4>
                      </a>
                    </li>
                    <li
                      class='shrink-0'
                      style={
                        modelType === MODEL_EXP
                          ? { backgroundColor: '#7d8ec1' }
                          : {}
                      }
                    >
                      <a
                        onClick={(e) => handleSelectType(e, MODEL_EXP)}
                        href='#'
                        class='flex flex-col items-center text-dark hover:text-custom duration-300 px-2 leading-10 rounded-full block text-[26px] text-center'
                      >
                        <img
                          src='/exploisionfan.png'
                          style={{
                            objectFit: 'contain',
                            width: 'auto',
                            height: '50px',
                            paddingTop: 7,
                          }}
                        />
                        <h4 class='font-bold text-xs'>Explosion Fan</h4>
                      </a>
                    </li>
                    <li
                      class='shrink-0'
                      style={
                        modelType === MODEL_FIRE
                          ? { backgroundColor: '#7d8ec1' }
                          : {}
                      }
                    >
                      <a
                        onClick={(e) => handleSelectType(e, MODEL_FIRE)}
                        href='#'
                        class='flex flex-col items-center text-dark hover:text-custom duration-300 px-2 leading-10 rounded-full block text-[26px] text-center'
                      >
                        <img
                          src='/fireprooffan.png'
                          style={{
                            objectFit: 'contain',
                            width: 'auto',
                            height: '50px',
                            paddingTop: 7,
                          }}
                        />
                        <h4 class='font-bold text-xs'>Fireproof Fan</h4>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class='py-3' style={{ paddingTop: 0, marginTop: 0 }}>
                  <section class='bg-light'>
                    <div class='grid grid-cols-1 mt-0'>
                      <div class='mx-auto w-full max-w-[650px]'>
                        <div class='accordion-container faq space-y-2.5 mt-10'>
                          {models.map((item) => (
                            <Model
                              model={item}
                              key={item.id}
                              filter={modelType}
                              selecteds={selecteds}
                              handleSelect={handleSelect}
                              handleDeselect={handleDeselect}
                              toggleSelectSize={toggleSelectSize}
                              sizeSelected={sizeSelected}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <Reporter
              handleSearch={handleSearch}
              fans={fans}
              modelType={modelType}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
